import { render } from "./bell_notifications.vue?vue&type=template&id=73fe5a3b&scoped=true"
import script from "./bell_notifications.vue?vue&type=script&lang=js"
export * from "./bell_notifications.vue?vue&type=script&lang=js"

import "./bell_notifications.vue?vue&type=style&index=0&id=73fe5a3b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fe5a3b"]])

export default __exports__